// extracted by mini-css-extract-plugin
var _1 = "TOCStickyControl-module__actionButtons--Wz5pa";
var _2 = "TOCStickyControl-module__alignRight--oSSb0";
var _3 = "TOCStickyControl-module__animateUploadProgressBarWidth--O4GPe";
var _4 = "TOCStickyControl-module__animatedBackground--gCKEc";
var _5 = "TOCStickyControl-module__closeAreaButton--lSWmT";
var _6 = "TOCStickyControl-module__content--WvKsy";
var _7 = "TOCStickyControl-module__hasBanner--pvfuk";
var _8 = "TOCStickyControl-module__isPublicView--FVibq";
var _9 = "TOCStickyControl-module__isReorderingWithDragAndDrop--VmrBH";
var _a = "TOCStickyControl-module__isShowingTOC--A3A00";
var _b = "TOCStickyControl-module__monitor--nF4A9";
var _c = "TOCStickyControl-module__popOver--PEEkl";
var _d = "TOCStickyControl-module__root--r4g0A";
var _e = "TOCStickyControl-module__scrolled--sJbZt";
var _f = "TOCStickyControl-module__tablet--BedW0";
var _10 = "TOCStickyControl-module__title--iOMRX";
var _11 = "TOCStickyControl-module__titleContainer--AjIVo";
var _12 = "TOCStickyControl-module__tocButton--h4xrj";
var _13 = "TOCStickyControl-module__tocContainer--PKYgP";
var _14 = "TOCStickyControl-module__tocHoverArea--ZtFw0";
var _15 = "TOCStickyControl-module__tocIcon--T6EGc";
var _16 = "TOCStickyControl-module__tocPopOverContainer--z9wgq";
var _17 = "TOCStickyControl-module__tocPopOverContent--mfrh1";
export { _1 as "actionButtons", _2 as "alignRight", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "closeAreaButton", _6 as "content", _7 as "hasBanner", _8 as "isPublicView", _9 as "isReorderingWithDragAndDrop", _a as "isShowingTOC", _b as "monitor", _c as "popOver", _d as "root", _e as "scrolled", _f as "tablet", _10 as "title", _11 as "titleContainer", _12 as "tocButton", _13 as "tocContainer", _14 as "tocHoverArea", _15 as "tocIcon", _16 as "tocPopOverContainer", _17 as "tocPopOverContent" }
